import { useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import toast from 'react-hot-toast'
import { useAuth } from '../hooks/useAuth'
import Button from '../components/common/Button'
import Input from '../components/common/Input'

export default function Login() {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [loading, setLoading] = useState(false)
    const { login } = useAuth()
    const navigate = useNavigate()
    const [params] = useSearchParams()
    const next = params.get('next')

    async function handleSubmit(e) {
        e.preventDefault()
        setLoading(true)
        const result = await login(email, password)
        setLoading(false)
        if (result.success) {
            toast.success('Welcome back!')
            // If they got here via a magic link or a protected route, send them
            // back to where they were trying to go.
            navigate(next && next.startsWith('/') ? next : '/')
        } else {
            toast.error(result.message)
        }
    }

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-ghasc-navy-dark to-ghasc-navy px-4">
            <div className="bg-white rounded-2xl shadow-xl p-8 w-full max-w-md">
                <div className="text-center mb-6">
                    <h1 className="text-2xl font-bold text-ghasc-navy">GHASC Literature</h1>
                    <p className="text-sm text-gray-500 mt-1">
                        Georgian Heartland Area Service Committee
                    </p>
                </div>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <Input
                        id="email"
                        label="Email"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        autoComplete="email"
                        autoFocus
                    />
                    <Input
                        id="password"
                        label="Password"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        autoComplete="current-password"
                    />
                    <Button
                        type="submit"
                        loading={loading}
                        className="w-full"
                    >
                        Log In
                    </Button>
                </form>
                <div className="text-center text-sm pt-3">
                    <Link to="/forgot-password" className="text-ghasc-navy hover:underline">
                        Forgot your password?
                    </Link>
                </div>
                <p className="text-center text-sm text-gray-500 pt-6 mt-6 border-t border-gray-100">
                    New here?{' '}
                    <Link to="/signup" className="text-ghasc-navy font-medium hover:underline">
                        Sign up for an account
                    </Link>
                </p>
            </div>
        </div>
    )
}
